module.exports = __webpack_public_path__ + "static/img/sjks.c928812a.png";